<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="400px"
    :center="true"
  >
    <div class="content">
      <div v-show="isCanvasShow" class="canvas-dom" id="canvasDom" ref="canvasDom">
        <!-- <div>{{date}}</div> -->
        <fm-head :title="date"></fm-head>
        <div class="playlist">
          <div
            class="playlist__item"
            v-for="({id, songName, singerName, message, likeCount}) in list"
            :key="id"
          >
            <div class="song">
              <div class="song-name">{{songName}}</div>
              <div class="singer-name">{{singerName}}</div>
              <div v-if="message" class="message">{{message}}</div>
            </div>
            <div class="comment"></div>
            <div class="like">{{likeCount}}</div>
          </div>
        </div>
        <div class="bottom">
          <!-- 前往婚礼纪后花园公众号点歌或<br>
          扫码点歌 -->
          前往婚礼纪后花园公众号获取今日歌单或<br>
          扫码进入歌单参与互动，为喜欢的歌点赞
          <img class="qrcode" :src="qrcode">
        </div>
      </div>
      <img class="img" ref="img" :src="img">
    </div>
    <div slot="footer" class="dialog-footer">
      右键保存或复制图片
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import Head from '@/components/Head'
import dayjs from 'dayjs'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import bus from '@/utils/eventBus'

export default {
  name: 'DailyListImg',
  components: {
    [Dialog.name]: Dialog,
    'fm-head': Head,
  },
  props: {
    // date: {
    //   type: String
    // },
    // list: {
    //   type: Array,
    //   default: () => []
    // },
    // dialogVisible: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data () {
    return {
      date: '',
      list: [],
      dialogVisible: false,
      qrcode: '',
      img: '',
      isCanvasShow: true,
      // loading: Loading.service({
      //   target: '.content'
      // })
    }
  },
  computed: {
    today: () => dayjs().format('YYYY-MM-DD').toString()
  },
  methods: {
    createPlaylistImg() {
      const canvasDom = this.$refs.canvasDom
      const width = canvasDom.getBoundingClientRect().width
      const height = canvasDom.getBoundingClientRect().height
      const canvasObj = document.createElement('canvas')
      const scale = 1080 / width
      canvasObj.width = width * scale
      canvasObj.height = height * scale
      // canvasObj.getContext('2d').scale(scale, scale)
      html2canvas(canvasDom, {
        canvas: canvasObj,
        scale,
        width: width,
        height: height,
        // imageTimeout: 3000,
        useCORS: true
      }).then(canvas => {
        const dataUrl = canvas.toDataURL('image/png')
        console.log(dataUrl)
        this.img = dataUrl
        this.isCanvasShow = false
        this.loading = false
      })
    },
    qrcodeImg(date) {
      // const date = '2019-11-14'
      QRCode.toDataURL(`https://fm520.hlj-backyard.com/#/daily?date=${date}`)
      // QRCode.toDataURL(`https://fm520.hlj-backyard.com/#/`)
        .then(url => {
          this.qrcode = url
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  created () {
  },
  mounted() {
    bus.$on('createCanvasImg', ({date, list}) => {
      this.qrcodeImg(date)
      this.date = dayjs(date).format('YYYY/M/D').toString()
      this.list = list
      this.dialogVisible = true
      this.isCanvasShow = true
      this.img = ''
      this.loading = true

      setTimeout(() => {
        this.createPlaylistImg()
      }, 1000)
    })
  }
}
</script>

<style lang="less" scoped>
@icon-like: '../../assets/like.png';

.content {
  border: 1px solid #666;
}
.canvas-dom {
  // border: 2px solid #666;
  background: #fff;
  .playlist {
    flex: 1;
    display: flex;
    flex-direction: column;
    &__item {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      border-top: 1px solid #f1f1f1;
      padding: 20px;
      line-height: 1;
      position: relative;
      .song {
        min-height: 60px;
      }
      .song-name {
        font-size: 20px;
        font-weight: bold;
        color: #000;
      }
      .singer-name {
        margin-top: 8px;
        font-size: 14px;
        color: #999;
      }
      .message {
        flex: 1;
        margin-top: 10px;
        // padding: 0 10px;
        font-size: 14px;
        line-height: 20px;
        position: relative;
        &:before {
          content: '“ ';
          font-size: 20px;
          font-weight: bold;
          color: #999;
        }
        &:after {
          content: ' ”';
          font-size: 20px;
          font-weight: bold;
          color: #999;
        }
      }
      .ft {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
      }
      .comment {
        font-size: 14px;
        color: #000;
      }
      .like {
        display: flex;
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #999;
        cursor: pointer;
        &:before {
          content: '';
          margin-right: 2px;
          display: block;
          width: 18px;
          height: 18px;
          background: url(@icon-like) 0 0 no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .bottom {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    font-size: 12px;
  }
  .qrcode {
    width: 80px;
    height: 80px;
  }
}
.img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/PlaylistImg.vue